import { render, staticRenderFns } from "./JyClassify.vue?vue&type=template&id=fb74450e&scoped=true&"
import script from "./JyClassify.vue?vue&type=script&lang=js&"
export * from "./JyClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb74450e",
  null
  
)

export default component.exports